// Turns a sourcing run's `channel_counts` into a display-ready summary for
// the RunTabs record bar (BRAND-9515 Idea-2 rework), e.g. "10 Instagram · 5
// TikTok". Reuses the existing platform filter i18n labels rather than
// inventing new ones.

const CHANNEL_LABEL_KEYS: Record<string, string> = {
  instagram: 'creatorSearch.filter.platform.instagram',
  tiktok: 'creatorSearch.filter.platform.tiktok',
  youtube: 'creatorSearch.filter.platform.youtube',
}

export interface IChannelCountPart {
  channel: string
  count: number
  // null for a channel TRIBE doesn't have a platform label for yet — the
  // caller renders the raw channel key verbatim instead of throwing
  // (unknown-tolerant, matching the sourcing-run status convention).
  labelKey: string | null
}

export const channelCountsSummaryParts = (
  channelCounts: Record<string, number>,
): IChannelCountPart[] =>
  Object.entries(channelCounts).map(([channel, count]) => ({
    channel,
    count,
    labelKey: CHANNEL_LABEL_KEYS[channel] ?? null,
  }))
